import React, { type RefObject } from 'react';
import { useSelector } from 'react-redux';
import {
    overquotaAbClearDownloadVarBHideDownload,
    overquotaAbClearDownloadVarCDisableDownload,
} from 'reactApp/appHelpers/featuresHelpers/features/overquotaAbClearDownload';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { DownloadDisabledTooltip } from 'reactApp/ui/DownloadDisabledTooltip/DownloadDisabledTooltip';
import { ETooltipPlacement } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';
import { useTooltip } from 'reactApp/ui/Tooltip/Tooltip.hooks';

interface Props {
    isEnabled: boolean;
    onLeft?: boolean;
    targetRef: RefObject<HTMLDivElement>;
}

export const useDownloadDisabledTooltip = ({ isEnabled, targetRef, onLeft }: Props) => {
    const isOverquota = useSelector(UserQuotaSelectors.isOverquotaBySpaceAndApi);

    const enableClickTip = isEnabled && isOverquota && overquotaAbClearDownloadVarCDisableDownload;
    const hideDownloadAb = isEnabled && isOverquota && overquotaAbClearDownloadVarBHideDownload;

    const { open } = useTooltip({
        id: 'disableDownloadTip',
        defaultProps: {
            target: targetRef,
            withinModal: true,
            closable: false,
            closeOnOutsideClick: true,
            closeOnScroll: true,
            closeOnNoTarget: true,
            placement: onLeft ? ETooltipPlacement.leftEnd : ETooltipPlacement.bottom,
            children: ({ onClose }) => <DownloadDisabledTooltip onClose={onClose} />,
        },
    });
    return { enableClickTip, openDisabledDownloadTip: open, hideDownloadAb };
};
